import { errorToLogObject } from 'utils/apiErrors';
import { getAccessToken } from 'utils/auth';
import { getBackofficeUrl } from 'utils/urls';

// GET {backoffice}/api/players/address-required
// Mirrors Unity's CashiersModel.ExecuteCheckAddressRequired (CashiersModel.cs:1185-1227).
// Server-side validation in apps/backoffice/app/Services/PlayerService::isAddressRequired
// — whitespace-only fields are treated as missing.
//
// Pure imperative: every call hits the network. No React state, no shared
// cache, no in-flight dedupe — callers act on the returned value at the time
// of the call so a just-saved address is reflected immediately.
// Fail-closed: any error or malformed response returns true so the user is
// blocked rather than silently bypassed when the backoffice is down.
export async function checkAddressRequired(): Promise<boolean> {
  try {
    const jwt = getAccessToken();
    const res = await fetch(`${getBackofficeUrl()}/api/players/address-required`, {
      cache: 'no-store',
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${jwt}`
      }
    });

    if (!res.ok) {
      throw new Error(`HTTP ${res.status}`);
    }

    const json = await res.json();
    const required = json?.data?.addressRequired;
    if (typeof required !== 'boolean') {
      throw new Error('Malformed response from /api/players/address-required');
    }
    return required;
  } catch (e: any) {
    console.error('[checkAddressRequired] Error:', errorToLogObject(e));
    return true;
  }
}
